import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import * as Typography from '../../../../atoms/Typography/Typography.js';

var CookieTypeContainer = styled.div({
    "&:not(:first-of-type)": {
        marginTop: tokens.spacing[7],
    },
    p: {
        marginBottom: "0",
    },
});
var CookieTypeTopRow = styled.label({
    height: "3rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "0",
});
var CookieTypeTitle = styled(Typography.Heading)({
    margin: "0",
});
var EssentialLabel = styled(Typography.Text)({
    color: tokens.color.airJordan.p,
    display: "inline-block",
});
var PreferenceDescription = styled(Typography.Text)({
    color: tokens.color.airJordan.p,
});

export { CookieTypeContainer, CookieTypeTitle, CookieTypeTopRow, EssentialLabel, PreferenceDescription };
//# sourceMappingURL=PreferenceItem.styles.js.map
